import { render, staticRenderFns } from "./RouterViewHolder.vue?vue&type=template&id=6bb667a0&scoped=true&"
import script from "./RouterViewHolder.vue?vue&type=script&lang=ts&"
export * from "./RouterViewHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb667a0",
  null
  
)

export default component.exports